import React from 'react';
import { useLocation } from 'react-router-dom';


const PatinetInfo = (props) => {
    const location = useLocation();
    const { rowData }  = props;
    return (
        <>
            {Object.keys(rowData && rowData?.state?.rowData)?.length > 0 ?
                <div className="action-buttons">
                    <div className="card">
                        <div className="card-body d-flex justify-content-between">
                            <div className="d-flex">
                                <p className="action-key-tag"><i class="fa fa-user" aria-hidden="true"></i>&nbsp;:&nbsp;</p>
                                <p className="action-value-tag">{location?.state?.rowData?.name || location?.state?.rowData?.patientName}</p>
                            </div>
                            <div className="d-flex">
                                <p className="action-key-tag"><i class="fa fa-child" aria-hidden="true"></i>&nbsp;:&nbsp;</p>
                                <p className="action-value-tag">{location?.state?.rowData?.age}</p>
                            </div>
                            <div className="d-flex">
                                <p className="action-key-tag"><i class="fa fa-mobile" aria-hidden="true"></i>&nbsp;:&nbsp;	</p>
                                <p className="action-value-tag">{location?.state?.rowData?.mobile}</p>
                            </div>
                            <div className="d-flex">
                                <p className="action-key-tag" ><i class="fa fa-list-ol" aria-hidden="true" tooltip="EMR Number"></i>&nbsp;:&nbsp;</p>
                                <p className="action-value-tag">{location?.state?.rowData?.emrNumber}</p>
                            </div>
                        </div>
                    </div>
                </div> : null}

        </>
    )
};

export default PatinetInfo;